import { computed, inject, Injectable, signal } from '@angular/core';
import { TAB_VALUE } from 'src/app/shared/components/listing-page/listing-page.types';
import { ListingPageModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { ListingTableComponent } from 'src/app/shared/components/listing-table/listing-table.component';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { FieldOperationsSensorsListingFiltersSourceService } from './field-operations-sensors-listing-filters-source.service';
import { FieldOperationsSensorsListingDataSourceService } from './field-operations-sensors-listing-data-source.service';
import { FieldOperationsSensorsListingExportConfigService } from './field-operations-sensors-listing-export-config.service';
import { createFieldOperationsSensorsColumns } from './field-operations-sensors-listing.columns';
import {
  FIELD_OPERATIONS_SENSORS_DEFAULT_SEARCH_TYPE,
  FIELD_OPERATIONS_SENSORS_SEARCH_TYPES
} from './field-operations-sensors-listing.search';
import { FIELD_OPERATIONS_SENSORS_SORT_FIELD } from './field-operations-sensors-listing.sort';
import { FieldOperationsSensorsFieldName } from './field-operations-sensors.types';

@Injectable()
export class FieldOperationsSensorsListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  readonly pageTitle = TranslateRegistry.get.INSTALLATION_HISTORY.TITLE.FIELD_OPERATIONS;
  readonly searchTypeList = signal(FIELD_OPERATIONS_SENSORS_SEARCH_TYPES);
  readonly selectedSearchType = signal(FIELD_OPERATIONS_SENSORS_DEFAULT_SEARCH_TYPE);
  readonly sorting = signal({
    columnName: FieldOperationsSensorsFieldName.LastFieldOperationDateUtc,
    orderDirection: OrderDirection.DESC
  });
  readonly tableColumns = computed(() => createFieldOperationsSensorsColumns());
  readonly filterSource = inject(FieldOperationsSensorsListingFiltersSourceService);
  readonly dataSource = inject(FieldOperationsSensorsListingDataSourceService);
  readonly exportConfig = inject(FieldOperationsSensorsListingExportConfigService);

  readonly selectionFieldName = 'deviceUID';
  readonly tableCmp = ListingTableComponent;
  readonly defaultTab = TAB_VALUE.Table;
  readonly sortField = FIELD_OPERATIONS_SENSORS_SORT_FIELD;

  get pageId(): ListingPageId {
    return ListingPageId.FieldOperationsSensors;
  }

  constructor() {
    super();
    this.listingPageModelRegistry.add(ListingPageId.FieldOperationsSensors, this);
  }
}
